<template>
  <div v-if="exportEx.show" class="q-pa-md q-gutter-sm">
    <q-dialog v-model="exportEx.show">
      <q-card>
        <div class="xlsx">
          <q-select label="Type" filled :options="excelList" v-model="type"></q-select>
          <div class="el">
            <q-btn color="negative" @click="exportEx.show = false">CLOSE</q-btn>
            <q-btn
              :loading="loading"
              @click="exportXlsx"
              :disable="loading || !type"
              color="primary"
            >EXPORT
            </q-btn>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "../axios/";

export default {
  props: {
    selection: Array,
  },
  data() {
    return {
      loading: false,
      excelList: ["Internal", "External"],
      type: "",
    };
  },
  methods: {
    async nameGenerator() {
      let name = `${this.type}ListForSale_`;
      var currentdate = new Date();
      var datetime =
        currentdate.getDate() +
        "_" +
        (currentdate.getMonth() + 1) +
        "_" +
        currentdate.getFullYear() +
        "_" +
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes() +
        ":" +
        currentdate.getSeconds();
      name += datetime;
      return name;
    },
    async exportXlsx() {
      this.loading = true;
      let url = `vehicle-analysis/export-list-for-sale/${this.type.toLowerCase()}`;
      if (this.previewCondition) {
        url = `vehicle-analysis/export-list-for-sale/${this.type.toLowerCase()}` +
          `?preview_condition=${this.previewCondition}`;
      }
      const body = {}
      const {
        data,
      } = await axios.post(
        url,
        {},
        {params: this.exportEx.params, responseType: 'blob'}
      );
      const windowURL = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = windowURL;
      const name = await this.nameGenerator();
      link.setAttribute("download", `${name}.xlsx`);
      document.body.appendChild(link);
      link.click();

      await this.clearVehicles();
      this.loading = false;
      this.exportEx = false;
    },
    clearVehicles() {
      this.$emit("clearVehicles", true);
    },
  },
  computed: {
    provider() {
      return this.$store.state.profit.provider
    },
    financial: {
      get() {
        return this.$store.state.profit.financial
      },
      set(val) {
        this.$store.commit('profit/SET_FINANCIAL', val)
      }
    },
    vehicles() {
      return this.$store.state.profit.vehicles;
    },
    exportEx: {
      get() {
        return this.$store.state.profit.exportEx;
      },
      set(val) {
        this.$store.commit("profit/SET_EXPORT", val);
      },
    },
    previewCondition: {
      get() {
        return this.$store.state.profit.previewCondition
      },
      set(val) {
        this.$store.commit('profit/SET_PREVIEW_CONDITION', val)
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.xlsx {
  padding: 15px;
  display: flex;
  flex-flow: column nowrap;
  width: 250px;
  .el {
    display: flex;
    flex-flow: row nowrap;
    button {
      &:last-child {
        margin-left: 5px;
      }
      &:first-child {
        margin-right: 5px;
      }
      flex: 0 1 calc(100% - 5px);
    }
    margin-top: 10px;
  }
}
</style>
